import createAPI from '../axios'

/* 迎新 */
const welcome = {
    captcha: config => createAPI('/welcome/createImageCode', 'post', config),
    login: config => createAPI('/welcome/login', 'post', config),
    save: config => createAPI('/welcome/save', 'post', config),
    submit: config => createAPI('/welcome/submit', 'post', config),
};

export default welcome;



// WEBPACK FOOTER //
// ./src/api/modules/welcome.js